'use strict';
module.exports = function normalisedIdentifier(identifier) {
	const normalised = (identifier && identifier.toLowerCase && identifier.toLowerCase()) || identifier;
	return normalised && normalised.trim && normalised.trim();
};
